module.exports = __webpack_public_path__ + "img/brand_research_illustration.68e8b1e5.svg";